import Vue from 'vue'
import { ValidationObserver, ValidationProvider, localize, extend } from 'vee-validate'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ja from 'vee-validate/dist/locale/ja.json'
import * as rules from 'vee-validate/dist/rules'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Object.keys(rules).forEach((rule) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  extend(rule, rules[rule])
})

// with typescript
for (const [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation,
  })
}

localize('ja', ja)
